/**
 * Coin icon + display-name helpers.
 * Icon renders the generated coin logo image, falling back to a colored initial
 * circle when the image is missing (all rotating pool coins use the fallback).
 * Rebrand generations tint the fallback color and append a "N.0" suffix.
 */
import { rebrandColor, type CoinConfig } from '../game/config/coins.js';
import { rebrandSuffix } from '../game/config/listing.js';
import type { CoinListing } from '../game/exchangeState.js';
import { t } from '../i18n/index.js';

/** Display name with the rebrand suffix, e.g. "MoonFrog 2.0". */
export function coinDisplayName(cfg: CoinConfig, listing?: CoinListing): string {
  return t(cfg.nameKey) + rebrandSuffix(listing?.revivedCount ?? 0);
}

export function coinIconHtml(cfg: CoinConfig, small = false, listing?: CoinListing): string {
  const sizeClass = small ? ' ex-coin-icon-sm' : '';
  const gen = listing?.revivedCount ?? 0;
  const color = rebrandColor(cfg.color, gen);
  const fallback = `this.outerHTML='<span class=&quot;ex-coin-icon${sizeClass}&quot; style=&quot;background:${color}&quot;>${cfg.symbol.slice(0, 2)}</span>'`;
  // Revived coins always use the fallback circle (no dedicated rebrand art yet).
  if (gen > 0) {
    return `<span class="ex-coin-icon${sizeClass}" style="background:${color}">${cfg.symbol.slice(0, 2)}</span>`;
  }
  return `<img class="ex-coin-icon ex-coin-icon-img${sizeClass}" src="assets/coins/${cfg.id}.png" alt="${cfg.symbol}" onerror="${fallback}" />`;
}
